<script lang="ts">
	import { ButtonVariant } from "../../../core/schema/ButtonVariant.js";
	import type { WebPartner } from "@core/schema/WebPartner.js";
	import { getPartnersGoldDetailPath } from "@core/schema/paths/getPartnersGoldDetailPath.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import Formatted from "./common/Formatted.svelte";
	import Link from "./common/Link.svelte";
	import Media from "./common/Media.svelte";

	const { partner }: { partner: WebPartner } = $props();
	const { tenant } = getGlobalTemplateProps();
</script>

<div
	class={[
		"bg-white/50 flex flex-col p-3 md:p-6 w-32 md:w-64 min-h-[7rem] md:min-h-[13.125rem] rounded-xl md:rounded-3xl backdrop-blur-lg items-center",
	]}
>
	<div class="w-full min-h-6 md:min-h-12 flex items-center justify-center">
		<Media
			draggable={false}
			alt={`Logo firmy ${partner.name}`}
			source={partner.logo}
			height={48}
			width={208}
			class="h-full w-auto max-h-[24px] md:max-h-[48px] max-w-[104px] md:max-w-[208px] object-contain mx-auto"
			sourcesets={{
				"<2xl": [0, 208],
				">2xl": [0, 208],
			}}
		/>
	</div>
	<div class={["flex flex-col text-center", partner.industry === undefined && "mb-2"]}>
		<div class="text-2xs/[1] md:text-[1.25rem]/[1] font-medium text-black mt-3 md:mt-6">{partner.name}</div>
		{#if partner.industry !== undefined}
			<div class="text-[0.5rem]/[1] md:text-xs/[1] text-uppercase text-black my-2 md:mt-3">
				{partner.industry.name[tenant.locale]}
			</div>
		{/if}
	</div>
	{#if partner.hasDetail}
		<Link
			href={getPartnersGoldDetailPath(tenant, partner)}
			variant={ButtonVariant.Text}
			icon="arrow"
			class="flex items-end group/underline mt-auto gap-4"
		>
			<Formatted text="hover[[Detail]]" />
		</Link>
	{/if}
</div>
